var map = {
	"./decidim/avatar-multiuser.png": 53447,
	"./decidim/brands/google.svg": 22430,
	"./decidim/cc-badge.png": 45389,
	"./decidim/decidim-logo.svg": 79125,
	"./decidim/default-avatar.svg": 14997,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 22475,
	"./decidim/icons.svg": 77956,
	"./decidim/pattern.png": 82807,
	"./decidim/placeholder-card-g.svg": 86924,
	"./decidim/placeholder-card-l.svg": 58135,
	"./decidim/placeholder.jpg": 63502,
	"./decidim/remixicon.symbol.svg": 51300,
	"./decidim/vendor/leaflet/layers-2x.png": 62317,
	"./decidim/vendor/leaflet/layers.png": 1460,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 39045,
	"./decidim/vendor/leaflet/marker-icon.png": 58044,
	"./decidim/vendor/leaflet/marker-shadow.png": 38083,
	"./decidim/vendor/social-share-button/douban.svg": 4215,
	"./decidim/vendor/social-share-button/email.svg": 81056,
	"./decidim/vendor/social-share-button/facebook.svg": 46140,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 93496,
	"./decidim/vendor/social-share-button/hacker_news.svg": 30996,
	"./decidim/vendor/social-share-button/linkedin.svg": 99942,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 38847,
	"./decidim/vendor/social-share-button/pinterest.svg": 29550,
	"./decidim/vendor/social-share-button/reddit.svg": 99268,
	"./decidim/vendor/social-share-button/telegram.svg": 22345,
	"./decidim/vendor/social-share-button/tumblr.svg": 92038,
	"./decidim/vendor/social-share-button/twitter.svg": 7453,
	"./decidim/vendor/social-share-button/vkontakte.svg": 16831,
	"./decidim/vendor/social-share-button/wechat.svg": 36362,
	"./decidim/vendor/social-share-button/whatsapp.svg": 55594,
	"./decidim/vendor/social-share-button/x.svg": 22080,
	"./decidim/vendor/social-share-button/xing.svg": 53640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85782;